import React, { useContext } from "react";

import { Tagline } from "../../components/Tagline/Tagline";
import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";
import { MediaContent } from "./MediaContent/MediaContent";

import GeneralPageContext from "../../templates/GeneralPageContext";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";

import * as styles from "./component.module.less";

const MEDIA_LAYOUT_STANDARD = "standard";

function MediaText({
    data: {
        id,
        anker,
        tagline,
        headline,
        semanticOfHeadline,
        subheadline,
        ctaButton,
        secundarButton,
        mediaElements,
        mediaAlignRight,
        hideGrid,
        mediaLayout = MEDIA_LAYOUT_STANDARD,
        background,
        thumbnails,
        galleryImages
    },
    type
}) {
    const withGallery = mediaLayout === MEDIA_LAYOUT_STANDARD;

    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);

    return (
        <>
            <SectionContainer
                sectionId={anker}
                sectionClass={styles.mediaTextContentSection}
                containerClass={gcs(styles.mediaTextContentContainer, [
                    showAnchorNavigation,
                    styles.anchored
                ])}
                background={background}
                mediaAlignRight={mediaAlignRight}
            >
                <MediaContent
                    id={id}
                    mediaElements={mediaElements}
                    hideGrid={hideGrid}
                    withGallery={withGallery}
                    galleryImages={galleryImages}
                    thumbnails={thumbnails}
                />

                <div className={styles.containerMediaText}>
                    <header>
                        <Tagline>{tagline}</Tagline>

                        <Headline semanticOfHeadline={semanticOfHeadline}>
                            {headline}
                        </Headline>

                        <StructuredTextRenderer
                            data={subheadline}
                            contentElementType={type}
                        />
                    </header>

                    <div className={styles.mediaTextButtonContainer}>
                        <StructuredTextRenderer
                            data={ctaButton}
                            itemLinkType="cta"
                            contentElementType={type}
                            className={styles.mediaTextButton}
                        />

                        <StructuredTextRenderer
                            data={secundarButton}
                            className={styles.mediaTextButton}
                            itemLinkType="primary"
                            contentElementType={type}
                            itemLinkIcon="arrowRight"
                            itemLinkIconPosition="right"
                        />
                    </div>
                </div>
            </SectionContainer>
        </>
    );
}

export { MediaText };
